import { render, staticRenderFns } from "./sliderTpl.vue?vue&type=template&id=42a886ec&lang=html&"
import script from "./sliderTpl.vue?vue&type=script&lang=js&"
export * from "./sliderTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports